import axios from "axios";

export const state = {
    financialyears: [],
    currentFinancialYear: null,
};

const fetchingLogic = [
    { url: "/savings", action: "savings/fetchSavings" },
    { url: "/shares", action: "shares/fetchShares" },
    { url: "/account-balances", action: "accountbalances/fetchAccountBalances" },
    { url: "/membership-fees", action: "membershipfees/fetchMembershipFees" },
    { url: "/withdraws", action: "withdraws/fetchWithdraws" },
    { url: "/approved-loans", action: "loandisbursements/fetchLoanDisbursements" },
    { url: "/running-loans", action: "runningloans/fetchRunningLoans" },
    { url: "/closed-loans", action: "closedloans/fetchClosedLoans" },
    { url: "/credit-score-reports", action: "creditreports/fetchCreditReports" },
    { url: "/checkoff-lists", action: "checkofflists/fetchCheckoffLists" },
    { url: "/investment-returns", action: "investmentreturns/fetchInvestmentReturns" },
    { url: "/contributions", action: "contributions/fetchContributions" },
    { url: "/give-aways", action: "giveaways/fetchGiveAways" },
    { url: "/expenses", action: "expenses/fetchExpenses" },

];

export const getters = {
    financialyears: (state) => state.financialyears,
    currentFinancialYear: (state) => state.currentFinancialYear,
    currentFinancialYearRecord: (state) => {
        return (
            state.financialyears.find(
                (year) => year.id === state.currentFinancialYear,
            ) || null
        );
    },
};

export const mutations = {
    setYears(state, newValue) {
        state.financialyears = newValue;
    },

    setCurrentFinancialYear(state, newValue) {
        state.currentFinancialYear = newValue;
    },
};

export const actions = {
    async fetchFinancialYears({ commit }) {
        await axios.get("/financialyears").then((res) => {
            commit("setYears", res.data.years);
        });
    },

    fetchSetFinancialYearData({ commit, dispatch }, newValue) {
        const id = typeof newValue === "object" ? newValue.id : newValue;
        commit("setCurrentFinancialYear", id);

        const route = window.location.pathname;

        fetchingLogic.forEach(({ url, action }) => {
            if (route == url) {
                dispatch(action, null, { root: true });
            }
        });
    },
};
